export { BookInfo } from './BookInfo';
export type { BookInfoProps } from './BookInfo.types';
